import React, { useCallback } from 'react';

import { PureTranslator } from 'ggApp/modules/translator';

import { SubmitButton, Text, ErrorText } from './styles';

const getTranslationKeys = (gateway = {}) => {
    switch (gateway.type) {
        case 'paypal':
            return {
                textTk: 'NEW_CHECKOUT_REDIRECT_FORM_PAYPAL_TEXT',
                buttonTk: 'NEW_CHECKOUT_REDIRECT_FORM_PAYPAL_BUTTON_TEXT',
            };
        case 'sepa':
            return {
                textTk: 'NEW_CHECKOUT_REDIRECT_FORM_SEPA_TEXT',
                buttonTk: 'NEW_CHECKOUT_REDIRECT_FORM_SEPA_BUTTON_TEXT',
            };
        default:
            return {
                textTk: 'REDIRECT_FORM_REDIRECT_NOTICE',
                buttonTk: 'REDIRECT_FORM_SUBMIT_BUTTON_LABEL',
            };
    }
};

const RedirectFormUi = ({ gateway, formErrorState, setPaymentTermsInfo }) => {
    const { textTk, buttonTk } = getTranslationKeys(gateway);

    const showPaymentTerms = useCallback(
        (event) => {
            if (gateway.type !== 'sepa') return;
            event.preventDefault();
            setPaymentTermsInfo(gateway);
        },
        [gateway, setPaymentTermsInfo],
    );

    return (
        <>
            {!formErrorState && (
                <Text>
                    <PureTranslator tk={textTk} />
                </Text>
            )}
            {formErrorState && (
                <ErrorText error>
                    <PureTranslator tk="NEW_CHECKOUT_REDIRECT_FORM_ERROR_TEXT" />
                </ErrorText>
            )}
            <SubmitButton onClick={showPaymentTerms} small type="submit">
                <PureTranslator
                    tk={formErrorState ? 'NEW_CHECKOUT_REDIRECT_FORM_ERROR_BUTTON_TEXT' : buttonTk}
                />
            </SubmitButton>
        </>
    );
};

export default RedirectFormUi;
